import BlogDetailPage from "@/pages/blog/components/BlogDetailPage";

export default function BlogLaravelApiBestPractices() {
  return <BlogDetailPage slug="laravel-api-development-best-practices" />;
}